/* eslint-disable */
import React, { createContext, useState, useEffect, useContext, useCallback } from "react";
import { useAutoRefresh, parseRefreshInterval, parseIdleTimeout } from '../../../utils/useAutoRefresh';

import { fetchPricingQueueAPI } from "../../../api/user";
import { accessFeature, getEmployeeInfoAndReferenceData, validateApprover } from "../../shared/getEmployeeInfoAndReferenceData";
import { ContainerContext } from "../../../app/App";
import { CustomPropInterface } from "../../..";
import { transformString } from "../../../utils/utils";
export interface filterRequest {
  type?: string;
  status?: string;
  schedule?: string;
  fromDate?: string;
  toDate?: string;
  limit?: string;
  offset?: string;
  companyCode?: string[];
}
export const PricingQueueContext = createContext<any>("");
export default function PQContext(props: any) {
  const [isAlterOpen, setIsAlterOpen] = useState(false);

  const [autotermRange, setAutotermRange] = useState<any>([]);

  const sortDirection = {
    ASC: "asc",
    DESC: "desc",
  };
  const [hideMainPage, setHideMainPage] = useState(false);
  const [tableHeader, setTableHeader] = useState([
    {
      columnTitle: "Type",
      sortOrder: sortDirection.ASC,
      columnId: "type",
      IsSorted: true,
      IsSortable: false,
    },
    {
      columnTitle: "Schedule",
      sortOrder: sortDirection.ASC,
      columnId: "schedule",
      IsSorted: true,
      IsSortable: true,
    },
    {
      columnTitle: "Submitted Date & Time",
      sortOrder: sortDirection.ASC,
      columnId: "submittedDateTime",
      IsSorted: true,
      IsSortable: true,
    },
    {
      columnTitle: "Submitted by",
      sortOrder: sortDirection.ASC,
      columnId: "submittedBy",
      IsSorted: true,
      IsSortable: false,
    },
    {
      columnTitle: "Approved by",
      sortOrder: sortDirection.ASC,
      columnId: "approvedBy",
      IsSorted: true,
      IsSortable: false,
    },
    {
      columnTitle: "Comments",
      sortOrder: sortDirection.ASC,
      columnId: "comments",
      IsSorted: true,
      IsSortable: false,
    },
    {
      columnTitle: "Status",
      sortOrder: sortDirection.ASC,
      columnId: "status",
      IsSorted: true,
      IsSortable: false,
    },
    {
      columnTitle: "Progress",
      sortOrder: sortDirection.ASC,
      columnId: "progress",
      IsSorted: true,
      IsSortable: false,
    },
    {
      columnTitle: "Action",
      sortOrder: sortDirection.ASC,
      columnId: "action",
      IsSorted: true,
      IsSortable: false,
    },
  ]);
  const [comments, setComments] = useState<any>("");
  const [companyCode, setCompanyCode] = useState([]);
  const [isFranchiseeUser, setIsFranchiseeUser] = useState(false);
  const [noRecords, setNoRecords] = useState(false);
  const [tableBody, setTableBody] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [activeRowData, setActiveRowData] = useState<any>(null);
  const [pendingTableBody, setPendingTableBody] = useState<any>(null);
  const [pendingTotalCount, setPendingTotalCount] = useState<number | null>(null);
  const [approvalPopup, setApprovalPopup] = useState("");
  const [zoneDetails, setZoneDetails] = useState(false);
  const [loader, setLoader] = useState<any>('Y');
  const [alterPopUp, setAlterPopUp] = useState<any>();
  const [isApproved, setIsApproved] = useState(false);
  const [IsPackage, setIsPackage] = useState(false);
  const [approveDisable, setApproveDisable] = useState(false)
  const [rejectDisable, setRejectDisable] = useState(false)
  let rangeHeaders = [{
    heading: "Days on Rent Start",
    isSortable: true,
    sortDirection: "DESC",
    key: "startDay",
    isSorted: true,
  },
  {
    heading: "Days on Rent End",
    isSortable: true,
    sortDirection: "DESC",
    key: "endDay",
    isSorted: true,
  },
  {
    heading: "Discount %",
    isSortable: true,
    sortDirection: "DESC",
    key: "percentDiscount",
    isSorted: true,
  },
  ];
  const [rangeHeader, setRangeHeader] = useState<any>(rangeHeaders);
  const [somethingWentWrong, setSomethingWentWrong] = useState<any>(false); //something went wrong variable
  const [schedule, setSchedule] = useState([
    {
      label: "Select",
      value: "",
    },
  ]);
  const [indexValue, setIndexValue] = useState(0);
  let criteriaHeaderArr = [{
    heading: "Start Range",
    isSortable: true,
    sortDirection: "DESC",
    key: "startRange",
    isSorted: true,
  },
  {
    heading: "End Range",
    isSortable: true,
    sortDirection: "DESC",
    key: "endRange",
    isSorted: true,
  },
  {
    heading: "Discount",
    isSortable: true,
    sortDirection: "DESC",
    key: "discountValue",
    isSorted: true,
  },
  ];
  const [criteriaHeader, setCriteriaHeader] = useState(criteriaHeaderArr);
  const [queueType, setQueueType] = useState([
    {
      label: "Select",
      value: "",
    },
  ]);
  const [queueStatusType, setQueueStatusType] = useState([
    {
      label: "Select",
      value: "",
    },
  ]);
  const [filterReq, setFilterReq] = useState<filterRequest>({ offset: "1" });
  const [pageCount, setPageCount] = useState(0);
  const [refreshIntervalMs, setRefreshIntervalMs] = useState<number | null>(null);
  const [idleTimeoutMs, setIdleTimeoutMs] = useState<number>(5 * 60 * 1000);
  const [isapprovalPopup, setIsapprovalPopup] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [isApprover, setIsApprover] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const containerData = useContext(ContainerContext) as CustomPropInterface;
  const [fullLoader, setFullLoader] = useState(false);
  const [packageCriteria, setPackageCriteria] = useState();
  const [criteriaRange, setcriteriaRange] = useState();
  const costBasedApprovalData = {
    zone: '-',
    department: '-',
    subdepartment: '-',
    bracket: '-',
    startDate: '-',
    endDate: '-',
    publishPriceForExisitingRMS: '-',
    publishPriceWhenCostChanges: '-',
    schedule: '-',
    minRatePct: '-',
    maxRatePct: '-',
    minRateNew: '-',
    maxRateNew: '-',
    minRateUsed: '-',
    maxRateUsed: '-',
    turns: '-',
    termMax: '-',
    initialAmount: '-',
    growth: '-',
    lineShiftLr: '-',
    lineShiftUd: '-',
    usedRateAdjustment: '-'
  }
  const [hasAccess, setHasAccess] = useState({
    costBasedPricingEditAccess: false,
    costBasedPricingApproveAccess: false,
    pricingQueueEditAccess: false,
    pricingQueueApproveAccess: false,
    zoneBasedPricingEditAccess: false,
    zoneBasedPricingApproveAccess: false,
  })
  const [hasApproveAccess, setHasApproveAccess] = useState();
  const [costBasedPricingApprovalData, setCostBasedPricingApprovalData] = useState(costBasedApprovalData)
  const zoneBasedApprovalData = {
    zoneNumber: '',
    departmentNumber: '',
    subdepartmentNumber: '',
    bracketNumber: '',
    termPrem: '',
    turn: '',
    reCalculateTerm: '',
    newAndUsedRatePrem: '',
    brandNewRatePrem: '',
    startDate: '',
    endDate: '',
    publishPriceForExisitingRMS: ''
  }
  const [zoneBasedPricingApprovalData, setZoneBasedApprovalFormData] = useState(zoneBasedApprovalData)
  const getReferenceandPricingQueueDetail = async () => {
    try {
      setLoader("Y");
      await getEmployeeInfoAndReferenceData(containerData, {
        type: ["SCHEDULE", "QUEUE_STATUS_TYPE", "QUEUE_TYPE", "CONFIG"],
      }).then((rep: any) => {
        if (rep.status == 200) {
          sessionStorage.setItem("EmployeeId", rep.employeeId);
          sessionStorage.setItem("userName", rep.userName);
          sessionStorage.setItem("emailId", rep.email);
          console.log(
            validateApprover(rep.menuConfigArray),
            "the approver is in queu",
            rep.menuConfigArray
          );

          setIsApprover(validateApprover(rep.menuConfigArray));
          setHasAccess({
            ...hasAccess, costBasedPricingEditAccess: accessFeature(rep.menuConfigArray, 'Cost Based Pricing', 'edit'),
            costBasedPricingApproveAccess: accessFeature(rep.menuConfigArray, 'Cost Based Pricing', 'approve'),
            zoneBasedPricingEditAccess: accessFeature(rep.menuConfigArray, 'Zone Based Pricing', 'edit'),
            zoneBasedPricingApproveAccess: accessFeature(rep.menuConfigArray, 'Zone Based Pricing', 'approve'),
            pricingQueueEditAccess: accessFeature(rep.menuConfigArray, 'Pricing Queue', 'edit'),
            pricingQueueApproveAccess: accessFeature(rep.menuConfigArray, 'Pricing Queue', 'approve')
          })
          setSchedule(
            formatDropdown(
              rep.dropdownData.schedule.sort((a: any, b: any) =>
                a["refCode"] < b["refCode"] ? -1 : 1
              ),
              "refCode",
              "refCode"
            )
          );
          setQueueType(
            formatDropdown(
              rep.dropdownData.queueType.sort((a: any, b: any) =>
                a["refCode"] < b["refCode"] ? -1 : 1
              ),
              "refCode",
              "refCode"
            )
          );
          setQueueStatusType(
            formatDropdown(
              rep.dropdownData.queueStatusType.sort((a: any, b: any) =>
                a["refCode"] < b["refCode"] ? -1 : 1
              ),
              "refCode",
              "refCode"
            )
          );
          setIsFranchiseeUser(rep.isFranchiseeUser);
          setCompanyCode(rep.companyCode);
          setRefreshIntervalMs(parseRefreshInterval(rep.dropdownData?.config));
          setIdleTimeoutMs(parseIdleTimeout(rep.dropdownData?.config));
          if (rep.isFranchiseeUser) {
            if (rep.companyCode.length)
              fetchPricingQueueDetail({ companyCode: [rep.companyCode[0]] });
            else
              throw new Error(
                "CompanyCode is not supposed to be empty for an franchiseeUser"
              );
          } else {
            fetchPricingQueueDetail();
          }

        } else {
          setLoader(true);
          setSomethingWentWrong(true);
        }
      });
    } catch (err) {
      console.log(err, "the error in 724");
      setLoader(true);
      setSomethingWentWrong(true);
    }
  };
  const formatDropdown = (req: any, val1: string, val2: string) => {
    let arr: any = [
      {
        label: "Select",
        value: "",
      },
    ];
    req.forEach((item: any) => {
      arr.push({
        label: transformString(item[val1]),
        value: item[val2],
      });
    });

    return arr;
  };
  useEffect(() => { }, [tableBody]);
  const fetchPricingQueueDetail = async (params: filterRequest = {}, silent?: boolean) => {
    try {
      if (!silent) setLoader("Y");
      if (!silent) setTotalRowCount(0);
      let req: filterRequest = filterReq;
      req.offset = params.offset
        ? `${params.offset}`
        : filterReq?.offset?.toString();
      req.companyCode = params?.companyCode ? params.companyCode : undefined;
      req.limit = "25";
      const rep: any = await fetchPricingQueueAPI(req);
      console.log(rep, "The rrep from the queue");
      if (rep.data.pricingQueueDetails && rep.status == 200) {
        if (silent && isapprovalPopup) {
          // Dialog is open — buffer the data, apply when dialog closes
          setPendingTableBody(rep.data.pricingQueueDetails);
          setPendingTotalCount(rep.data.totalRecordsCount);
        } else {
          setTotalRowCount(rep.data.totalRecordsCount);
          setPageCount(Math.ceil(rep.data.totalRecordsCount / 25));
          setTableBody(rep.data.pricingQueueDetails);
          setNoRecords(false);
        }
      } else if (rep.data == "") {
        setNoRecords(true);
        setTotalRowCount(0);
      } else {
        if (!silent) setSomethingWentWrong(true);
      }
    } catch (err) {
      if (!silent) setSomethingWentWrong(true);
      console.log("err", err);
    } finally {
      if (!silent) setLoader(true);
    }
  };

  const onQueueSilentRefresh = useCallback(() => {
    const params = isFranchiseeUser && companyCode.length
      ? { companyCode: [companyCode[0]] }
      : {};
    fetchPricingQueueDetail(params, true);
  }, [filterReq, isFranchiseeUser, companyCode, isapprovalPopup]);

  // Flush buffered data when the dialog closes
  useEffect(() => {
    if (!isapprovalPopup && pendingTableBody && pendingTotalCount !== null) {
      setTableBody(pendingTableBody);
      setTotalRowCount(pendingTotalCount);
      setPageCount(Math.ceil(pendingTotalCount / 25));
      setNoRecords(false);
      setPendingTableBody(null);
      setPendingTotalCount(null);
    }
  }, [isapprovalPopup]);

  // Snapshot the row data when opening a detail view (deep copy to avoid shared references)
  const openRowDetail = (index: number) => {
    setActiveRowData(JSON.parse(JSON.stringify((tableBody as any[])[index])));
    setIndexValue(index);
  };

  useAutoRefresh({ intervalMs: refreshIntervalMs, idleTimeoutMs, isDialogOpen: false, onRefresh: onQueueSilentRefresh });
  return (
    <PricingQueueContext.Provider
      value={{
        sortDirection,
        noRecords,
        setNoRecords,
        IsPackage,
        setIsPackage,
        alterPopUp,
        setAlterPopUp,
        indexValue,
        setIndexValue,
        packageCriteria,
        setPackageCriteria,
        companyCode,
        setCompanyCode,
        tableHeader,
        isRejected,
        setIsRejected,
        setTableHeader,
        loader,
        setLoader,
        totalRowCount,
        setTotalRowCount,
        isapprovalPopup,
        setIsapprovalPopup,
        filterReq,
        setFilterReq,
        pageNumber,
        setPageNumber,
        pageCount,
        setPageCount,
        getReferenceandPricingQueueDetail,
        tableBody,
        setTableBody,
        hideMainPage,
        setHideMainPage,
        schedule,
        criteriaRange, setcriteriaRange,
        setSchedule,
        comments,
        setComments,
        queueType,
        setQueueType,
        queueStatusType,
        setQueueStatusType,
        zoneDetails,
        autotermRange,
        setAutotermRange,
        setZoneDetails,
        isAlterOpen,
        setIsAlterOpen,
        fetchPricingQueueDetail,
        approvalPopup,
        rangeHeader,
        setRangeHeader,
        fullLoader,
        setFullLoader,
        somethingWentWrong,
        setSomethingWentWrong,
        isApprover,
        setIsApprover,
        setApprovalPopup,
        isFranchiseeUser,
        setIsFranchiseeUser,
        isApproved,
        setIsApproved,
        criteriaHeader, setCriteriaHeader,
        costBasedPricingApprovalData, setCostBasedPricingApprovalData,
        hasAccess, setHasAccess, approveDisable, setApproveDisable,
        rejectDisable, setRejectDisable, hasApproveAccess, setHasApproveAccess,
        zoneBasedPricingApprovalData, setZoneBasedApprovalFormData,
        activeRowData, setActiveRowData, openRowDetail
      }}
    >
      {props.children}
    </PricingQueueContext.Provider>
  );
}
